
import {
  Vue, Component,
} from 'vue-property-decorator';
import API from '@/lib/API';
import { Category } from '@/types';

@Component
export default class Config extends Vue {
  excludedCategoryIds: number[] = []
  loading = false
  saving = false
  saveSuccess = false
  saveError = false

  get categories(): Category[] {
    return this.$store.getters.categories || [];
  }

  async created() {
    console.log('Config: created()'); // eslint-disable-line no-console
    await this.loadConfig();
  }

  async loadConfig() {
    this.loading = true;
    try {
      const response = await API.getDuplicateCheckExcludedCategories();
      if (response && Array.isArray(response.categoryIds)) {
        this.excludedCategoryIds = response.categoryIds;
      }
    } catch (error) {
      console.error('Error loading config:', error); // eslint-disable-line no-console
    } finally {
      this.loading = false;
    }
  }

  removeCategory(category: Category) {
    this.excludedCategoryIds = this.excludedCategoryIds.filter((id) => id !== category.id);
  }

  async saveConfig() {
    this.saving = true;
    this.saveSuccess = false;
    this.saveError = false;

    try {
      await API.updateDuplicateCheckExcludedCategories(this.excludedCategoryIds);
      this.saveSuccess = true;
    } catch (error) {
      console.error('Error saving config:', error); // eslint-disable-line no-console
      this.saveError = true;
    } finally {
      this.saving = false;
    }
  }
}
